//inserts slashes automatically in dob text field
export default function dobFormatting(ev, thisState, func) {
  if (ev.which !== 8) {
    let input = ev.target.value;
    let out = input.replace(/\D/g, '');
    let len = out.length;

    if (len > 1 && len < 4) {
      out = out.substring(0, 2) + '/' + out.substring(2, 3);
    } else if (len >= 4) {
      out = out.substring(0, 2) + '/' + out.substring(2, 4) + '/' + out.substring(4, len);
      out = out.substring(0, 10)
    }
    func(out);
    if (input.length > 0 && out.length == 0) {
      thisState.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
    }
  }
}
